import { combineReducers } from "redux";
// Front
import Layout from "./layout/reducer";
// Authentication
import Login from "./auth/login/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import ResetPassword from "./auth/resetpwd/reducer";
//profile
import Profile from "./profile/reducer";
//users
// import users from './users/reducer';
//departments
import departments from "./departments/reducer";
//lost orders
import lostOrders from "./lostOrders/reducer";
import actShipping from "./actShipping/reducer";
//customer service
import customerService from "./customerService/reducer";
//transfers service
import transfers from "./transfers/reducer";
import calculator from "./calculator/reducer";
import meetings from "./meeting/reducer";
import priceList from "./priceList/reducer";
//battles
import battles from "./battlefield/reducer";
//priority
import priority_orders from "./priority/reducer";
//priority
import stats from "./stats/reducer";
//purchases
import purchases from "./purchases/reducer";
//dash
import dashboard from "./dashboard/reducer";
//dash
import domains from "./domains/reducer";

import { priorityUkApi } from "../services/PriorityUkService";
import { priorityMoscowApi } from "../services/PriorityMoscowService";
import { priorityUAEApi } from "../services/PriorityUAEService";
import { priorityPLApi } from "../services/PriorityPLService";
import { leaveApi } from "../services/LeaveService";
import { logDelsApi } from "../services/LogisticFeeService";
import { ordersApi } from "../services/OrderService";
import { catalogApi } from "../services/CatalogService";
import { infoApi } from "../services/InfoService";
import { usersApi } from "../services/UsersService";
import { pricesApi } from "../services/PriceService";
import { marketingApi } from "../services/MarketingService";
import { notificationsApi } from "../services/NotificationsService";
import { transfersEuropeApi } from "../services/TransfersService";
import { calculatorApi } from "../services/CalculatorService";
import transferReducer from "./transfers/transferSlice";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  ForgetPassword,
  // private,
  ResetPassword,
  Profile,
  // users,
  departments,
  lostOrders,
  actShipping,
  customerService,
  transfers,
  calculator,
  priceList,
  meetings,
  battles,
  priority_orders,
  stats,
  purchases,
  dashboard,
  domains,
  [priorityUkApi.reducerPath]: priorityUkApi.reducer,
  [priorityMoscowApi.reducerPath]: priorityMoscowApi.reducer,
  [priorityUAEApi.reducerPath]: priorityUAEApi.reducer,
  [priorityPLApi.reducerPath]: priorityPLApi.reducer,
  [leaveApi.reducerPath]: leaveApi.reducer,
  [logDelsApi.reducerPath]: logDelsApi.reducer,
  [ordersApi.reducerPath]: ordersApi.reducer,
  [catalogApi.reducerPath]: catalogApi.reducer,
  [catalogApi.reducerPath]: catalogApi.reducer,
  [infoApi.reducerPath]: infoApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [pricesApi.reducerPath]: pricesApi.reducer,
  [marketingApi.reducerPath]: marketingApi.reducer,
  [notificationsApi.reducerPath]: notificationsApi.reducer,
  [transfersEuropeApi.reducerPath]: transfersEuropeApi.reducer,
  [calculatorApi.reducerPath]: calculatorApi.reducer,
  transferReducer: transferReducer,
});

export default rootReducer;
